import React from 'react';
import './Contact.css';


const Contact = () => {
  return (
    <div>
      <div className="contact">
        <p><i>Our program is designed to support independent living and empower individuals to achieve their goals.</i></p>
        {/*<div className='btn-container'>
          <Link to="/about"><div id='contact-about-btn' className="contact-btn">
            <h4>Our Mission</h4>
          </div></Link>
          <Link to="/services"><div id='contact-services-btn' className="contact-btn">
            <h4>How We Help</h4>
          </div></Link>
        </div>*/}
      </div>
    </div>
  );
};

export default Contact;
